module.exports = __webpack_public_path__ + "banner-client.158c61e2dbb0bd5083b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background/banner-client.png
// module id = 488
// module chunks = 5